import styled from "styled-components";

export const Container = styled.div`
	.confirm-modal {
		margin-top: 25px;
	}
`;
